//获取托盘模式产品线列表
export const GET_PRODUCT_LINE_LIST = "GET_PRODUCT_LINE_LIST";
//获取托盘模式某条产品线下的商品列表
export const GET_PLINE_PRODUCT = "GET_PLINE_PRODUCT";
//设置产品线列表滚动位置
export const SET_PLINE_SCROLLTOP = "SET_PLINE_SCROLLTOP";
//设置产品线商品列表滚动位置
export const SET_PLINE_PRODUCT_SCROLLTOP = "SET_PLINE_PRODUCT_SCROLLTOP";


// WEBPACK FOOTER //
// ./src/store/product-line/type.js